import React, { useState, useRef } from 'react';
import { Modal, Image } from 'semantic-ui-react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './CarouselModal.css';

const CarouselModal = props => {
    const { trigger, sliderPictures, open, onClose } = props;
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [fade, setFade] = useState(sliderPictures.length > 5 ? 'right' : '');
    const slider1 = useRef();
    const slider2 = useRef();

    const NextArrow = (props) => {
      const { style, onClick, className, isSmall } = props;
      const disabled = className.includes('slick-disabled') ? 'disabled' : '';
      disabled && setFade('left');
      return (
        <div
          className={`carousel_arrows next ${disabled} ${isSmall}`}
          style={{ ...style }}
          onClick={onClick}
        />
      );
    }

    const PrevArrow = (props) => {
      const { style, onClick, className, isSmall } = props;
      const disabled = className.includes('slick-disabled') ? 'disabled' : '';
      disabled && setFade('right');
      return (
        <div
          className={`carousel_arrows prev ${disabled} ${isSmall}`}
          style={{ ...style }}
          onClick={onClick}
        />
      );
    }

    const changeName = (i) => {
      const last = i.indexOf('.');
      const first = i.indexOf('_');
      const getName = i.substring(first + 1, last);
      return getName;
    }

    const setting = {
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      fade: true,
      arrows: true,
    };

    return (
      <Modal
          onClose={() => onClose(false)}
          open={open}
          trigger={trigger}
          size={window.innerWidth > 900 || (window.innerWidth > 750 && window.innerHeight > 1000) ? "large" : "tiny"}
          centered
          style={{ background: 'transparent' }}
          className="carousel_modal"
      >
          <Modal.Content style={{ background: 'transparent' }}>
            {/* big slider */}
            <Slider
              className="big_slide"
              asNavFor={nav2}
              ref={slider1 => setNav1(slider1)}
              {...setting}
              prevArrow={<PrevArrow />}
              nextArrow={<NextArrow />}
            >
              {sliderPictures.map(i => (
                <div key={i}>
                  <div
                    style={{
                      width: '100%',
                      height: '25px',
                      lineHeight: '20px',
                      color: '#fff',
                      fontSize: '18px',
                      display: 'block',
                      fontFamily: 'system-ui',
                    }}>{changeName(i)}</div>
                  <Image src={i} />
                </div>
              ))}
            </Slider>
            {/* small slider */}
            <Slider
              className={`small_slides ${fade}`}
              asNavFor={nav1}
              ref={slider2 => setNav2(slider2)}
              slidesToShow={5}
              swipeToSlide={false}
              slidesToScroll={1}
              focusOnSelect={true}
              arrows
              swipe={false}
              infinite={false}
              prevArrow={<PrevArrow isSmall="small" />}
              nextArrow={<NextArrow isSmall="small" />}
              responsive={[
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 4,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 4,
                  }
                }
              ]}
            >
              {sliderPictures.map(i => (
                <div key={i}>
                  <Image src={i} />
                </div>
              ))}
            </Slider>
          </Modal.Content>
      </Modal>
    )
}

export default CarouselModal;
